import * as yup from "yup";

// Yup allows overriding the field name within the schema with the `label` function. We pick up that label here to use
// within the `useLocalizedYupResolver` hook when localizing the error message.
// See https://github.com/jquense/yup/issues/2109
const wrapWithFieldLabel =
  (i18nMeta: { key: string }) =>
  ({ label }: { label: string }) => ({ ...i18nMeta, fieldLabel: label });

yup.setLocale({
  mixed: {
    default: wrapWithFieldLabel({ key: "yup.mixed.default" }),
    required: wrapWithFieldLabel({ key: "yup.mixed.required" }),
  },
  string: {
    email: wrapWithFieldLabel({ key: "yup.string.email" }),
    matches: wrapWithFieldLabel({ key: "yup.string.matches" }),
  },
  array: {
    min: wrapWithFieldLabel({ key: "yup.array.min" }),
  },
});
